import GeneralTranslations from "../../../Common/ModuleTranslations/fr";

export default {
  locale: "fr",
  name: "Informations légales",
  translation: { displayName: "Traductions" },
  fields: {
    list: [
      ...GeneralTranslations.fields.list,
      { fieldName: "hotelTicker", displayName: "Code hôtel" },
      { fieldName: "property", displayName: "Type de politique" },
    ],
    form: [
      ...GeneralTranslations.fields.form,
      { fieldName: "id" },
      { fieldName: "hotelTicker", displayName: "Code hôtel" },
      {
        fieldName: "property",
        displayName: "Type de politique",
        optionDisplay: {
          PRIVACY_POLICY: { label: "Politique de confidentialité" },
          COMMUNICATIONS_POLICY: { label: "Politique de communication" },
        },
        helpText:
          "Politique de confidentialité : Texte qui indique la conformité avec la LOPD et le RGPD</br>" +
          "Politique de communication : Texte que l'utilisateur lira afin d'accepter de recevoir des offres et promotions par e-mail",
      },
      { fieldName: "text", displayName: "Texte" },
    ],
  },
};
